<template>
    <div slot="content">
        <div class="table-area">
            <div class="table-b">
                <div class="table-header">
                    <div class="table-name">
                        <h3 class="ico_table_name">{{ `AS접수모델` }}</h3>
                    </div>
                    <div class="grid-tbl-box">
                        <ag-grid-vue 
                            ref="grid" 
                            :style="gridStyle"
                            class="ag-theme-alpine"
                            :enableRangeSelection="true"
                            :column-defs="columnDefs"
                            :grid-options="gridOptions"
                            :row-data="data"
                            :default-col-def="defaultColDef"
                            :framework-components="frameworkComponent"
                            @grid-ready="onReady"
                            @cell-clicked="onCellClicked" 
                            @first-data-rendered="onFirstDataRendered"/>
                    </div>
                </div>
            </div>
        </div>
        <!-- 유/무상 s. -->
        <div class="table-area">
            <div class="table-a">
                <div class="table-name">
                <h3 class="ico_table_name">유/무상</h3>
                </div>
                <el-form>
                    <el-row>
                        <el-col :span="4">
                            <el-form-item label="접수:">
                                <el-input v-model="payYnNm" readonly></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="4">
                            <el-form-item label="처리:">
                                <el-input v-model="procPayYnNm" readonly></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="16">
                            <el-form-item label="변경사유">
                                <el-row>
                                    <el-col :span="24">
                                        <el-col :span="6">
                                            <el-input v-model="changePayYnNm" readonly></el-input>
                                        </el-col>
                                        <el-col :span="18">
                                            <el-input v-model="changePayYnMemo" readonly></el-input>
                                        </el-col>
                                    </el-col>
                                </el-row>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </div>
        <!-- 유/무상 e. -->
        <!-- 접수/처리유형 s. -->
        <div class="table-area">
            <div class="table-a">
                <div class="table-name">
                <h3 class="ico_table_name">접수/처리유형</h3>
                </div>
                <el-form>
                    <el-row>
                        <el-col :span="4">
                            <el-form-item label="접수:">
                                <el-input v-model="asClassNm" readonly></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="4">
                            <el-form-item label="처리:">
                                <el-input v-model="changeAsClassNm" readonly></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="16">
                            <el-form-item label="변경사유">
                                <el-row>
                                    <el-col :span="24">
                                        <el-col>
                                            <el-input v-model="changeAsClassMemo" readonly></el-input>
                                        </el-col>
                                    </el-col>
                                </el-row>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </div>
        <!-- 접수/처리유형 e. -->

        <!-- 수리내역 s. -->
        <div class="table-area">
            <div class="table-a">
                <div class="table-name">
                    <h3 class="ico_table_name">수리내역</h3>
                </div>
                <el-table
                    :data="tableAsRepair"
                    style="width: 100%">
                    <el-table-column
                    prop="asRepairCat1"
                    label="증상구분"
                    width="150">
                    </el-table-column>
                    <el-table-column
                    prop="asRepairCat2"
                    label="고장증상"
                    width="150">
                    </el-table-column>
                    <el-table-column
                    prop="asRepairCat3"
                    label="고장부위"
                    width="150">
                    </el-table-column>
                    <el-table-column
                    prop="asRepairAmt"
                    label="기술료"
                    header-align="left"
                    :formatter="getElNumberFormat"
                    align="right"
                    width="100">
                    </el-table-column>
                    <el-table-column
                    prop="description"
                    label="상세수리내역"
                    width="300">
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <!-- 수리내역 e. -->

        <!-- 사용/회수자재 s. -->
        <div class="table-area">
            <div class="table-a">
                <div class="table-name">
                <h3 class="ico_table_name">사용/회수자재</h3>
                </div>
                <el-table
                    :data="tableAsRepairItem"
                    style="width: 100%">
                    <el-table-column
                    prop="itemCd"
                    label="사용품번"
                    width="120">
                    </el-table-column>
                    <el-table-column
                    prop="itemNm"
                    label="사용품명"
                    width="200">
                    </el-table-column>
                    <el-table-column
                    prop="itemQty"
                    label="사용수량"
                    header-align="left"
                    align="right"
                    :formatter="getElNumberFormat"
                    width="90">
                    </el-table-column>
                    <el-table-column
                    prop="unitPrice3"
                    label="단가"
                    header-align="left"
                    align="right"
                    :formatter="getElNumberFormat"
                    width="100">
                    </el-table-column>
                    <el-table-column
                    prop="itemAmt3"
                    label="금액"
                    header-align="left"
                    align="right"
                    :formatter="getElNumberFormat"
                    width="100">
                    </el-table-column>
                    <el-table-column
                    prop="recallItemCd"
                    label="회수품번"
                    width="150">
                    </el-table-column>
                    <el-table-column
                    prop="recallItemNm"
                    label="회수품명"
                    width="180">
                    </el-table-column>
                    <el-table-column
                    prop="recallItemQty"
                    label="회수수량"
                    header-align="left"
                    align="right"
                    :formatter="getElNumberFormat"
                    width="100">
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <!-- 사용/회수자재 e. -->

        <!-- 특기사항, 수리비 s. -->
        <div class="talbe-contain" style="display: flex;">
            <div class="table-area" style="margin-right: 30px; width: 40%;">
                <div class="table-a">
                    <div class="table-name">
                        <h3 class="ico_table_name">수리비</h3>
                    </div>
                    
                    <el-table
                        :data="tableRepair"
                        style="width: 100%">
                        <el-table-column
                        prop="asItemUnitFee"
                        label="자재비"
                        header-align="left"
                        align="right"
                        :formatter="getElNumberFormat"
                        width="87">
                        </el-table-column>
                        <el-table-column
                        prop="asRepairFee"
                        label="기술료"
                        header-align="left"
                        align="right"
                        :formatter="getElNumberFormat"
                        width="87">
                        </el-table-column>
                        <el-table-column
                        prop="asRepairFeeAmt"
                        label="청구금액"
                        header-align="left"
                        align="right"
                        :formatter="getElNumberFormat"
                        width="87">
                        </el-table-column>
                        <el-table-column
                        prop="asRepairFeeAmtReal"
                        label="실청구금액"
                        header-align="left"
                        align="right"
                        width="100">
                        </el-table-column>
                    </el-table>
                </div>
                <div class="table-a">
                    <el-descriptions border>
                        <el-descriptions-item label="정산년월" v-if="showSquareYymm">
                            <el-date-picker  type="date" placeholder="Pick a date" v-model="squareYymm" style="width: 90%;" value-format="yyyy-MM" :picker-options="datePickerOptions"></el-date-picker>
                        </el-descriptions-item>
                        
                        <el-descriptions-item label="정산년월" v-else>{{ squareYymmStr }}</el-descriptions-item>
                    </el-descriptions>
                </div>
            </div>
            <div class="table-area" style="width: 60%;">
                <div class="table-a">
                    <div class="table-name">
                        <h3 class="ico_table_name">정산비용</h3>
                    </div>
               
                    <div class="grid-tbl-box">
                        <ag-grid-vue 
                            ref="subGrid" 
                            :style="subGridStyle"
                            class="ag-theme-alpine"
                            :enableRangeSelection="true"
                            :column-defs="subColumnDefs"
                            :grid-options="subGridOptions"
                            :row-data="subData"
                            :default-col-def="defaultColDef"
                            :framework-components="frameworkComponent"
                            @cell-value-changed="onSubCellValueChange"
                            @grid-ready="onReadySub"/>
 
                    </div>
                </div>
            </div>
        </div>
        <div style="margin-bottom: 20px;">
            <el-row class="el__btn__group">
                <el-button type="info" icon="el-icon-document" @click="openModal(1)">
                    수리내역서
                </el-button>
                <el-button type="warning" icon="el-icon-edit-outline" v-if="showAsPayChange" @click="openModal(2)">
                    유무상변경
                </el-button>
                <el-button type="danger" icon="el-icon-edit-outline" v-if="showAsRealFeeChange" @click="openModal(3)">
                    실청구금액변경
                </el-button>
                <el-button type="primary" icon="el-icon-folder-checked" v-if="showAsConfirm" @click="openModal(4)">
                    승인 
                </el-button>
                <el-button type="primary" icon="el-icon-folder-checked" v-if="showAsConfirmCancel" @click="openModal(5)">
                    승인취소
                </el-button>
                <el-button type="primary" icon="el-icon-folder-checked" v-if="showAsSquare" @click="openModal(6)">
                    정산
                </el-button>
                <el-button type="primary" icon="el-icon-close" v-if="showAsSquareCancel" @click="openModal(7)">
                    정산취소
                </el-button>
            </el-row>
        </div>
        <!-- 특기사항, 수리비 e. -->
    </div>
</template>

<script>
/**
 * * mixins
 */
import lucoms from '@/mixin/lucoms';

/**
 * lodash
 */
import _ from 'lodash';
/**
 * * components
 */
import {AgGridVue} from 'ag-grid-vue';
import DhxCalendar from '@/components/Dhx/DhxCalendar.vue';
import DatepickerCellRenderer from '@/components/elementUI/datepicker-cell-renderer';
import SelectCellRenderer from '@/components/agGrid/select-cell-renderer';
import RadioCellRenderer from '@/components/agGrid/radio-cell-renderer';
import CheckboxCellRenderer from '@/components/agGrid/checkbox-cell-renderer';

/**
 * * Inner Modals
 */
import PayChange from './PayChange';
import RepairHst from './RepairHst';
import BillAmtChange from './BillAmtChange';

export default {
    mixins: [lucoms],
    components: {AgGridVue, DhxCalendar},
    data() {
        return {
            value: 'test',
            listKey: '01',
            lists: [{key: '01', value: 'test'}],
            payYnNm: '', /** 유/무상 */
            procPayYnNm: '', /** 유/무상 */
            payYn: '', /** 유/무상 */
            payYnList: [{key: '', value: ''}], /** 유/무상 */
            payYnIdList: [{key: '', value: ''}], /** 유/무상 */
            payYnLoadCnt: 0,
            changePayYnCdList: [{key: '', value: ''}], /** 유/무상 변경사유*/
            changePayYnCdShow: false,
            changePayYnCd: '',
            changePayYnNm: '', /** 변경사유 */
            changePayYnMemo: '', /** 변경사유 메모 */ 
            asClassNm: '',    /** 접수명 */
            changeAsClassCd: '',    /** 접수/처리유형 변경사유 코드*/
            changeAsClassNm: '',    /** 접수/처리유형 변경사유 명칭*/
            changeAsClassCdInit: '', /** 접수/처리유형 변경사유 코드*/
            changeAsClassCdList: [{key: '', value: ''}], /** 접수/처리유형 */
            changeAsClassMemo: '',  /** 접수/처리유형 변경사유 */
            asStatus: '', /** 진행상태 */
            showAsPayChange: false, /** 유무상변경 */
            showAsRealFeeChange: false, /** 실청구금액변경 */
            showAsConfirm: false, /** 승인 */
            showAsConfirmCancel: false, /** 승인취소 */
            showAsSquare: false, /** 정산 */
            showAsSquareCancel: false, /** 정산취소 */
            showAsUnitPrice1: false, /** 정산비용 */
            inAmtReal: 0,
            asId: '',
            processList: [],
            selProcIdx: -1, /** 선택된 AS접수모델 index */
            tabCacheLoadData: {},  /** tab을 클릭시 셋팅된 데이타 : AS접수모델 클릭시 재로딩하면 시간이 걸려서 캐싱하여서 로딩시키기 위해 */

            tableAsRepair: [ /** 수리내역 */
                {
                asRepairCat1: '증상구분',
                asRepairCat2: '고장증상',
                asRepairCat3: '고장부위',
                asRepairAmt: '0',
                description: '상세수리내역'
            },],
            tableAsRepairItem: [ /** 사용/회수자재 */
                {
                 asRepairItemId: '', 
                 itemId: '', 
                 itemGroup: '',
                 itemGroupNm: '', 
                 useModelNm: '', 
                 itemCd: '', 
                 itemNm: '', 
                 itemQty: '', 
                 unitPrice3: '', 
                 itemAmt3: '', 
                 recallItemCd: '', 
                 recallItemNm: '', 
                 recallItemQty: ''
            },],
            tableRepair: [ /** 수리비 */
                {
                asItemUnitFee: '자재비',
                asRepairFee: '기술료',
                asRepairFeeAmt: '청구금액',
                asRepairFeeAmtReal: '실청구금액'
            },],
            tableSquare: [ /** 정산비용 */
                {
                asUnitPrice1: '', /** 기본비용 */
                asEtcPrice1: '', /** 원거리수당 */
                asEtcPrice2: '', /** 기타비용 */
                asItemUnitFee: '', /** 자재비 */
                asUnitFee: '', /** 이관비 */
                asSumAmt: '' /** 합계 */
            },],
            squareYymm: '', /** 정산년월 */
            squareYymmStr: '', /** 정산년월 */
            showSquareYymm: false,
            currYymm: this.$moment().format('YYYY-MM'),
            
            form: { //테스트 폼 데이터
                model: '',  //모델
                prodNo: '', //제조번호
                dt: '2022-12-12',
            },
            data: [],
            subData: [], /** 정산비용 */
            // AG-GRID OPTION [START]
            gridStyle : 'padding-top:40px; width: 100%;height: 200px; min-height:100px;',
            subGridStyle : 'width: 100%;height: 200px; min-height:100px;',
            defaultColDef: {
                resizable: true
                , filter: true
                , sortable: true
            },
            gridApi: null,
            columnApi: null,
            columnDefs: [],
            subGridApi: null,
            subColumnApi: null,
            subColumnDefs: [], /** 정산비용 */
            gridOptions: {
                enableColResize: true,
                enableFilter: true,
                animateRows: false,
                enableSorting: true,
            },
            subGridOptions: {
                enableColResize: true,
                enableFilter: true,
                animateRows: false,
                enableSorting: true,
            },
            frameworkComponent : {
                datePicker: DatepickerCellRenderer,
                select: SelectCellRenderer,
                radio: RadioCellRenderer,
                checkbox: CheckboxCellRenderer,
            },
            //AG-GRID OPTION [END]
            datePickerOptions: {
                disabledDate (date) {
                    return date < new Date('1971-01-01')
                }
            },
        }
    },
    mounted() {
        this.getCombo({flag: 'INIT'})
        this.$emit("loadTab", {"tabNm":"3", "index": 0})
        
    },
    methods: {
        onFirstDataRendered(params) {
            const initIdx = 0;
            params.api.forEachNode((node) => {
                //node.setSelected(node.rowIndex === initIdx);
                if(node.rowIndex === initIdx) {
                    const {model, prodNo} = node.data;
                    this.form = _.merge(this.form, {model, prodNo});
                    node.setSelected(true);
                }
            });
        },
        onReady(params) {
            this.gridApi = params.api;
            this.columnApi = params.columnApi;
            this.createColumnDefs();

            //set data
            // const updateData = (data) => params.api.setRowData(data);
            // this.data = [{chk: 'Y', model: 'L2200DMW-5GSTK', recptTp: '01', yn: 'N', prodNo: '903LMB700061'}, {chk: 'N', model: 'L2200DMW-5GSTK+', recptTp: '02', yn: 'Y', prodNo: '907LMB160120', prchsDt: '20221211'}];
            // updateData(this.data);

        },
        onReadySub(params) {
            this.subGridApi = this.subGridOptions.api;
            this.subColumnApi = this.subGridOptions.columnApi;
            this.createsubColumnDefs(); // 정산비용

        },
        getCombo(param) {
            if(param.flag === 'INIT'){
                // 유/무상 처리
                this.$http.get(`/api/codeMng/combo`, {params: {parentId: 353}}) // ChangePayYn
                    .then(response => {
                        console.log('payYnList data0 :', response.data )
                        this.payYnList = response.data || []
                        this.payYnLoadCnt++
                        console.log('payYnList data :', response.data )
                    });
                
                // 유/무상 처리
                this.$http.get(`/api/codeMng/combo/catId`, {params: {parentId: 353}}) // ChangePayYn
                    .then(response => {
                        this.payYnIdList = response.data || []
                        this.payYnLoadCnt++
                        console.log('payYnList data2 :', response.data )
                    });    
    
                // 접수/처리유형     
                this.$http.get(`/api/codeMng/combo`, {params: {parentId: 344}}) // ChangeAsClass
                    .then(response => {
                        this.changeAsClassCdList = response.data || []
                    });
                
               

            } else {
                console.log('getCombo aaa=== ', param)
                if(param.parentId === ''){
                    this.changePayYnCdShow =  false
                } else{
                    this.changePayYnCdShow =  true

                    // 변경사유
                    this.$http.get(`/api/codeMng/combo`, {params: {parentId: param.parentId}})
                        .then(response => {
                            this.changePayYnCdList = response.data || []
                            this.changePayYnCdList.unshift({key:'', value:'전체'})
                            this.changePayYnCd = ''
                    });
                }
            } 
                
        },
        createColumnDefs() {
            this.columnDefs = [
                {
                    headerName:'선택',
                    field:'chk', 
                    width:50,
                    hide: true,
                    cellRenderer: 'checkBox',
                    ellRendererParams: {
                          trueValue: true    //true값  지정 defalut-"Y" ex) "Y", true, "1"
                        , falseValue: false  //false값 지정 defalut-"N" ex) "N", false, "0"
                        , disable: true
                    },
                    cellStyle: (params) => {
                        const idx = params.rowIndex;
                        if(idx === this.selProcIdx){
                            return {textAlign: 'center', backgroundColor: '#D5E6A3'};
                        } else {
                            return {textAlign: 'center'};
                        }
                    }
                },
                {
                    headerName:'순번',
                    field:'no', 
                    width:80,
                    valueFormatter: function(params) {               
                        return params.node.rowIndex+1;
                    },
                    cellStyle: (params) => {
                        const idx = params.rowIndex;
                        if(idx === this.selProcIdx){
                            return {textAlign: 'center', backgroundColor: '#D5E6A3'};
                        } else {
                            return {textAlign: 'center'};
                        }
                    }
                },
                {
                    headerName:'제조사',
                    field:'makerNm', 
                    width:140,
                    cellStyle: (params) => {
                        const idx = params.rowIndex;
                        if(idx === this.selProcIdx){
                            return {textAlign: 'center', backgroundColor: '#D5E6A3'};
                        } else {
                            return {textAlign: 'center'};
                        }
                    }
                },
                {
                    headerName:'제품군',
                    field:'modelGroupNm', 
                    width:180,
                    cellStyle: (params) => {
                        const idx = params.rowIndex;
                        if(idx === this.selProcIdx){
                            return {textAlign: 'center', backgroundColor: '#D5E6A3'};
                        } else {
                            return {textAlign: 'center'};
                        }
                    }
                },
                {
                    headerName:'모델',
                    field:'modelNm', 
                    width:180,
                    cellStyle: (params) => {
                        const idx = params.rowIndex;
                        if(idx === this.selProcIdx){
                            return {textAlign: 'center', backgroundColor: '#D5E6A3'};
                        } else {
                            return {textAlign: 'center'};
                        }
                    }
                },
                {
                    headerName:'제조번호',
                    field:'serialNo', 
                    width:130,
                    cellStyle: (params) => {
                        const idx = params.rowIndex;
                        if(idx === this.selProcIdx){
                            return {textAlign: 'center', backgroundColor: '#D5E6A3'};
                        } else {
                            return {textAlign: 'center'};
                        }
                    }
                },
                {
                    headerName:'구입년월',
                    field:'purchaseDt', 
                    width:130,
                    cellRenderer: 'datePicker',
                    cellRendererParams: {
                        // 참고 문서 : https://element.eleme.io/#/en-US/component/date-picker#attributes
                        type: 'month',
                        format: 'yyyy-MM',  //date format
                        valueFormat: 'yyyyMM',  //받는 model 의 결과 포맷
                        disable: true,
                    },
                    cellStyle: (params) => {
                        const idx = params.rowIndex;
                        if(idx === this.selProcIdx){
                            return {textAlign: 'center', backgroundColor: '#D5E6A3'};
                        } else {
                            return {textAlign: 'center'};
                        }
                    }
                },
            ];
        },
        createsubColumnDefs(){
            const vm = this
            this.subColumnDefs = [
                {
                    headerName:'기본비용',
                    field:'asUnitPrice1', 
                    width:90,
                    valueFormatter: (params) => {
                        return vm.getNumberFormat(params.value);
                    },  
                    cellStyle:(params) => {               
                        if(vm.showAsUnitPrice1){
                            return {textAlign: 'right', backgroundColor: '#fff8f7'}
                        }else{
                            return {textAlign: 'right'}
                        }
                    },
                    editable: (params) => {               
                        if(vm.showAsUnitPrice1){
                            return true
                        }else{
                            return false
                        }
                    } 
                },
                {
                    headerName:'원거리수당',
                    field:'asEtcPrice1', 
                    width:90,
                    valueFormatter: (params) => {
                        return vm.getNumberFormat(params.value);
                    },  
                    cellStyle:(params) => {               
                        if(vm.showAsUnitPrice1){
                            return {textAlign: 'right', backgroundColor: '#fff8f7'}
                        }else{
                            return {textAlign: 'right'}
                        }
                    },
                    editable: (params) => {               
                        if(vm.showAsUnitPrice1){
                            return true
                        }else{
                            return false
                        }
                    } 
                },
                {
                    headerName:'기타비용',
                    field:'asEtcPrice2', 
                    width:90,
                    valueFormatter: (params) => {
                        return vm.getNumberFormat(params.value);
                    },  
                    cellStyle:(params) => {               
                        if(vm.showAsUnitPrice1){
                            return {textAlign: 'right', backgroundColor: '#fff8f7'}
                        }else{
                            return {textAlign: 'right'}
                        }
                    },
                    editable: (params) => {               
                        if(vm.showAsUnitPrice1){
                            return true
                        }else{
                            return false
                        }
                    } 
                },
                {
                    headerName:'자재비',
                    field:'asItemUnitFee', 
                    width:90,
                    valueFormatter: (params) => {
                        return vm.getNumberFormat(params.value);
                    },  
                    cellStyle:(params) => {               
                        if(vm.showAsUnitPrice1){
                            return {textAlign: 'right', backgroundColor: '#fff8f7'}
                        }else{
                            return {textAlign: 'right'}
                        }
                    },
                    editable: (params) => {               
                        if(vm.showAsUnitPrice1){
                            return true
                        }else{
                            return false
                        }
                    } 
                },
                {
                    headerName:'이관비',
                    field:'asUnitFee', 
                    width:90,
                    valueFormatter: (params) => {
                        return vm.getNumberFormat(params.value);
                    },  
                    cellStyle:(params) => {               
                        if(vm.showAsUnitPrice1){
                            return {textAlign: 'right', backgroundColor: '#fff8f7'}
                        }else{
                            return {textAlign: 'right'}
                        }
                    },
                    editable: (params) => {               
                        if(vm.showAsUnitPrice1){
                            return true
                        }else{
                            return false
                        }
                    }     
                },
                {
                    headerName:'합계',
                    field:'asSumAmt', 
                    width:90,
                    valueFormatter: (params) => {
                        return vm.getNumberFormat(params.value);
                    },  
                    cellStyle:{textAlign: 'right'},
                }

            ]
        },
        changeRstHstInfo(param, index){
            console.log('RstHst changeRstHstInfo start param : ', param)
            this.tabCacheLoadData = param;
            
            const vAsDetailId = param.asDetailId || '';
            const vAsProcessId = param.asProcessId || '';
            console.log('why vAsDetailId: ', vAsDetailId)
            if(vAsDetailId === '') return false;

            if(param.callAsProcessSel1List){

                 // 모델정보
                this.tableModelInfo = param.callAsProcessSel1List
                                        .filter(x=>x.asDetailId===vAsDetailId && x.asProcessId===vAsProcessId)
                                        .map(y=>{
                                            return {
                                                    makerNm : y.makerNm,
                                                    modelGroupNm : y.modelGroupNm,
                                                    modelNm: y.modelNm,
                                                    serialNo: y.serialNo,
                                                    prodDt: y.prodDt,
                                                    purchaseDt: y.purchaseDt
                                                };
                                        }) || [];

                this.processList = param.callAsProcessSel1List.filter(x=>x.asDetailId===vAsDetailId && x.asProcessId===vAsProcessId) || []
            }

            // // 장애내역
            // this.tableTroubleData = param.callAsCat.map(x => { 
            //     let arrCat = x.asCatFullNm.split('>')
            //     if(arrCat){
            //         if(arrCat.length >= 2){
            //             x.asRepairCat1 = arrCat[1] 
            //         }
            //     }
            //     x.asRepairCat2 = x.asCatNm
            //     x.asRepairCat3 = x.description
            //     return x
            // })

            if(param.callAsDetail && param.callAsDetail.length>=index){
                // 유/무상 > 접수 : AS_DETAIL
                // 선택한 모델ROW에서 asDetailId 와 같은 접수건의 모델을 찾는다.
                // 동일한 접수번호(asDetailId)에 대해서 동일한 접수상태로 처리한다.
                const vDetailObj = param.callAsDetail.filter(x=>x.asDetailId == param.asDetailId);
                if(vDetailObj && vDetailObj.length>0){
                    let changePayYnObj = param.getCatDataByParent.filter(x => x.topKey === 'ChangePayYn' 
                                                                && x.catKey === vDetailObj[0].payYn) || [];
                    this.payYnNm = changePayYnObj[0].catNm || ''; // 유/무상
                }
            }
            this.asId = param.asId || ''
            
            let vChkCallAsProcessMstSelList = false
            if(param.callAsProcessMstSelList && param.callAsProcessMstSelList.length>0){
                vChkCallAsProcessMstSelList = true
            }

            if(param.callAsProcessSel1List && param.callAsProcessSel1List.length>=index){
                this.payYn = param.callAsProcessSel1List[index].payYn || 'Y'
                this.changePayYnMemo = param.callAsProcessSel1List[index].changePayYnMemo || ''
                const procPayYnObj = param.getCatDataByParent.filter(x => x.topKey === 'ChangePayYn' 
                                                            && x.catKey === param.callAsProcessSel1List[index].payYn) || []
                this.procPayYnNm = procPayYnObj && procPayYnObj.length>0 ? procPayYnObj[0].catNm : ''
            }
            
            // // 접수/처리유형
            this.asClassNm = param.callAsDetail[0].asClassNm || '' //접수

            if(vChkCallAsProcessMstSelList){
                this.changeAsClassCd = param.callAsProcessMstSelList[0].changeAsClassCd || '' //변경사유 코드
                const vChangeAsClassObj = this.changeAsClassCdList.filter(x=>x.key === this.changeAsClassCd)
                // console.log('vChangeAsClassObj: ', this.changeAsClassCdList, this.changeAsClassCd, vChangeAsClassObj)
                this.changeAsClassNm = vChangeAsClassObj && vChangeAsClassObj.length>0 ? vChangeAsClassObj[0].value : ''
                this.changeAsClassCdInit = this.changeAsClassCd
                this.changeAsClassMemo = param.callAsProcessMstSelList[0].changeAsClassMemo || '' //변경사유 메모
            }
            
            
            // // 수리내역
            this.tableAsRepair = param.callAsRepair.filter(x=>x.asDetailId==vAsDetailId && x.asProcessId==vAsProcessId) || []
            
            // 사용/회수자재
            this.tableAsRepairItem = param.callAsRepairItem.filter(x=>x.asDetailId==vAsDetailId && x.asProcessId==vAsProcessId) || []
            
            if(this.payYn === 'N' && this.tableAsRepairItem.length>0){
                // 무상이면 금액을 0
                this.tableAsRepairItem.map((x, i) => {
                    x.itemAmt3 = 0
                    return x
                })
            }
            
            // 수리비
            this.tableRepair = [
                {
                asItemUnitFee: param.callAsMstSelList[0].asItemUnitFee || '', /** 자재비 */
                asRepairFee: param.callAsMstSelList[0].asRepairFee || '', /** 기술료 */
                asRepairFeeAmt: param.callAsMstSelList[0].asRepairFeeAmt || '', /** 청구금액 */
                asRepairFeeAmtReal: param.callAsMstSelList[0].asRepairFeeAmtReal || '' /** 실청구금액 */
            },]

            const vSqObj = param.callAsMstSelList[0]
            let val1 = 0
            let val2 = 0
            let val3 = 0
            let val4 = 0
            let val5 = 0
            let vsum = 0
            
            if(vSqObj){
                val1 = vSqObj.asUnitPrice1 ? vSqObj.asUnitPrice1 : 0
                val2 = vSqObj.asEtcPrice1 ? vSqObj.asEtcPrice1 : 0
                val3 = vSqObj.asEtcPrice2 ? vSqObj.asEtcPrice2 : 0
                val4 = vSqObj.asItemUnitFee ? vSqObj.asItemUnitFee : 0
                val5 = vSqObj.asUnitFee ? vSqObj.asUnitFee : 0
                vsum = Number(val1) + Number(val2) + Number(val3) - (Number(val4) + Number(val5))
            }
            
            // 정산비용
            this.tableSquare = [
                {
                    asUnitPrice1 : val1 , /** 기본비용 */
                    asEtcPrice1 : val2 , /** 원거리수당 */
                    asEtcPrice2 : val3 , /** 기타비용 */
                    asItemUnitFee : val4 , /** 자재비 */
                    asUnitFee : val5, /** 이관비 */
                    asSumAmt : vsum /** 합계 */
                }   
            ] 
            this.subData = this.tableSquare
            
            let vSquareYymm = '' // 정산년월
            if(vChkCallAsProcessMstSelList){
                vSquareYymm = param.callAsProcessMstSelList[0].squareYymm || '' // 정산년월
                this.squareYymm = vSquareYymm
                if(vSquareYymm.length >=6) {
                    this.squareYymmStr = vSquareYymm.substring(0,4) + '년 ' + vSquareYymm.substring(5,7) + '월'
                }
            }

            this.showSquareYymm = false  // 달력표시안함.

            const vAstatus = vSqObj ? vSqObj.asStatus : ''

            /*  접수	Receipt
                진행중	Processing
                미처리	Suspension
                반려	Return
                처리완료	Complete
                승인	Confirm
                정산	Square
                */
            this.showAsPayChange = false // 유무상변경
            this.showAsRealFeeChange = false // 실청구금액변경
            this.showAsConfirm = false // 승인
            this.showAsConfirmCancel = false // 승인취소
            this.showAsSquare = false // 정산
            this.showAsSquareCancel = false // 정산취소

            this.showAsUnitPrice1 = true   // 정산비용
            this.asStatus = vAstatus
            
            if(vAstatus === 'Receipt'){

            } else if(vAstatus === 'Processing'){

            } else if(vAstatus === 'Suspension'){

            } else if(vAstatus === 'Return'){

            } else if(vAstatus === 'Complete'){
                this.showAsPayChange = true
                this.showAsRealFeeChange = true

            } else if(vAstatus === 'Confirm'){
                this.showAsConfirm = true
                this.showAsConfirmCancel = true
                this.showAsSquare = true

                this.showAsUnitPrice1 = false   // 정산비용
                
                this.squareYymm = this.currYymm // 정산년월을 수정할 수 있는 달력표시
                this.showSquareYymm = true  // 달력표시

            } else if(vAstatus === 'Square'){
                this.showAsSquareCancel = true
                
            }

            // TODO: 테스트후 삭제할것
            // this.showAsPayChange = true
            
        },
        onCellClicked(params) {
            const idx = params.rowIndex;
            const field = params.colDef.field;
            
            this.selProcIdx = idx;

            // 로딩속도 개선 : 직접호출시 속도가 늦음. 이미 로딩된 캐싱을 이용해서 2번 방법 사용.
            // 1. 직접호출
            //this.$emit("loadTab", {"tabNm":"3", "index": idx, "asDetailId": params.data.asDetailId, "asProcessId": params.data.asProcessId })
            
            // 2. 캐싱 사용
            this.tabCacheLoadData.asDetailId = params.data.asDetailId;
            this.tabCacheLoadData.asProcessId = params.data.asProcessId;
            this.changeRstHstInfo(this.tabCacheLoadData, idx);
            this.gridApi.redrawRows({ rowNodes: params });

            // this.data = this.data.map((x, i) => {
            //     if(idx === i) {
            //         if(x.chk === 'Y') {
            //             return x;
            //         } else {
            //             x.chk = x?.chk !== 'Y' ? 'Y' : 'N';
            //         }
            //     } else {
            //         if(x.chk === 'Y') {
            //             x.chk = x?.chk !== 'N' ? 'N' : 'Y';
            //         } else {
            //             return x;
            //         }
            //     }
            //     return x;
            // });

            // const {model, prodNo} = this.data.filter(x => x.chk === 'Y')?.[0];
            
            // this.form = _.merge(this.form, {model, prodNo});
        },
        /**
         * 정산내역 inner modal..
         * todo 필요한 데이터 components data 세팅 하기.. 
         */
        openModal(idx) {
            
            console.log('this.refs', this.$refs)
            if(idx === 4 || idx === 5) {
                // 승인(4), 승인취소(5)
                
                let vMsg01 = '승인하시겠습니까'
                let vMsg02 = '승인되었습니다'
                let vMsg03 = '승인에 실패 했습니다.'
                 
                if(idx === 5 ){
                    vMsg01 = '승인취소하시겠습니까'
                    vMsg02 = '승인취소되었습니다'
                    vMsg03 = '승인취소에 실패 했습니다.'
                }

                const vConfirmYn = idx === 4 ? 'Y' : 'N'
                const vSaveform = {
                    asId: this.asId,
                    confirmYn: vConfirmYn
                }

                this.$swal({
                    type: 'warning',
                    text: vMsg01,
                    showCancelButton: true,
                    confirmButtonText: '예',
                    cancelButtonText: '아니오',
                }).then((result) => {
                    if (result.value) {
                        this.$store.commit('loading')
                        this.$http.put("/api/asMng/call/saveConfirmUpt1", vSaveform)
                            .then(response => {
                                this.$swal({ type: 'success', text: vMsg02 });
                                
                            }).catch((e) => {
                                console.error(e);
                                this.$swal({ type: 'success', text: vMsg03 })
                            })
                            .finally(() => {
                                this.$store.commit('finish')
                            });
                    }
                });
            
            } else if(idx === 6 || idx === 7) {
                // 정산(6), 정산취소(7)
                
                let vMsg01 = '정산하시겠습니까'
                let vMsg02 = '정산되었습니다'
                let vMsg03 = '정산에 실패 했습니다.'
                 
                if(idx === 5 ){
                    vMsg01 = '정산취소하시겠습니까'
                    vMsg02 = '정산취소되었습니다'
                    vMsg03 = '정산취소에 실패 했습니다.'
                }

                let vAsUnitPrice1 = '0'
                let vAsEtcPrice1 = '0'
                let vAsEtcPrice2 = '0'
                let vAsItemUnitFee = '0'
                let vAsUnitFee = '0'
                if(this.subData && this.subData.length > 0){
                    vAsUnitPrice1 = this.subData[0].asUnitPrice1 || '0'
                    vAsEtcPrice1 = this.subData[0].asEtcPrice1 || '0'
                    vAsEtcPrice2 = this.subData[0].asEtcPrice2 || '0'
                    vAsItemUnitFee = this.subData[0].asItemUnitFee || '0'
                    vAsUnitFee = this.subData[0].asUnitFee || '0'
                }

                const vSquareYn = idx === 6 ? 'Y' : 'N'
                const vSaveform = {
                    asId: this.asId,
                    squareYn: vSquareYn,
                    squareYymm: this.squareYymm,
                    squareAsUnitPrice1 : vAsUnitPrice1, /** 기본비용 */
                    squareAsEtcPrice1 : vAsEtcPrice1, /** 원거리수당 */
                    squareAsEtcPrice2 : vAsEtcPrice2, /** 기타비용 */
                    squareAsItemUnitFee : vAsItemUnitFee, /** 자재비 */
                    squareAsUnitFee : vAsUnitFee    /** 이관비 */
                }

                this.$swal({
                    type: 'warning',
                    text: vMsg01,
                    showCancelButton: true,
                    confirmButtonText: '예',
                    cancelButtonText: '아니오',
                }).then((result) => {
                    if (result.value) {
                        this.$store.commit('loading')
                        this.$http.put("/api/asMng/call/saveSquserUpt", vSaveform)
                            .then(response => {
                                this.$swal({ type: 'success', text: vMsg02 });
                                
                            }).catch((e) => {
                                console.error(e);
                                this.$swal({ type: 'success', text: vMsg03 })
                            })
                            .finally(() => {
                                this.$store.commit('finish')
                            });
                    }
                });

            } else {

                // 2 : 실청구금액 변경
                const components = [{
                    key: 1, component: RepairHst, width: 1000,data: {asId: this.asId}
                }, {
                    key: 2, component: PayChange, width: 1000, data: {asId: this.asId, 
                        asStatus: this.asStatus, processList: this.processList, payYnList: this.payYnList}
                }, {
                    key: 3, component: BillAmtChange, width: 100, data: {asId: this.asId}
                }];

                const {component, data, width} = components.filter(x => x.key === idx)[0];
                console.log(component, data, width)
 
                this.$modal.open({
                    width: width,
                    component: component,
                    parent: this,
                    props: {
                        data
                    },
                    events: {
                        close(data) {
                            console.log('close', data);
                            if(data === 'OK'){
                                // 정산내역 재로딩
                                this.$parent.$parent.goOpen('INIT3', 0) 
                            }
                        },
                    }
                });

            }
            
        },
        onSubCellValueChange(params){
            const idx = params.rowIndex;

            console.log('MaincellValueChange start: ', params)
            
            /** AS접수제품 체크박스 변경시 */
            if(params.colDef.field === 'asClass'){
                
            }

            let val1 = params.data.asUnitPrice1 ? params.data.asUnitPrice1 : 0
            let val2 = params.data.asEtcPrice1 ? params.data.asEtcPrice1 : 0
            let val3 = params.data.asEtcPrice2 ? params.data.asEtcPrice2 : 0
            let val4 = params.data.asItemUnitFee ? params.data.asItemUnitFee : 0
            let val5 = params.data.asUnitFee ? params.data.asUnitFee : 0
            let vsum = Number(val1) + Number(val2) + Number(val3) - (Number(val4) + Number(val5))

            params.data.asSumAmt = vsum

            this.subGridApi.redrawRows({ rowNodes: params });
        },
        proc() {

        },
    }
}
</script>

<style lang="scss">
.el__btn__group{
    float: right;
    justify-content: space-between;
    align-items: center;
}
.el__btn__group > .el-col:not(:last-child) {
    margin-right: 8px;
}
</style>